import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideSearchX = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <path d="m13.5 8.5-5 5m0-5 5 5" />
      <circle cx={11} cy={11} r={8} />
      <path d="m21 21-4.3-4.3" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgLucideSearchX);
const Memo = memo(ForwardRef);
export default Memo;
